var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#40C067"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7828 5.17404C13.0568 5.41987 13.0738 5.83505 12.821 6.10137L7.42099 11.7889C7.29639 11.9201 7.12216 11.9963 6.93849 11.9999C6.75483 12.0034 6.5776 11.9341 6.4477 11.8078L4.1977 9.62029C3.9341 9.36401 3.9341 8.94849 4.1977 8.69221C4.46131 8.43593 4.88869 8.43593 5.1523 8.69221L6.90553 10.3967L11.829 5.21113C12.0819 4.94481 12.5089 4.9282 12.7828 5.17404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.46586abdd1639dd529d4cd9adf2bb6e2.svg";
export { ForwardRef as ReactComponent };